import { ICompany } from "@types";
import Image from "next/image";

import { Box } from "../../atoms/Box";

export interface SchoolProps {
  institute: ICompany;
  course: string;
  date: string;
  technologies: string[];
}

const School = ({ institute, course, date, technologies }: SchoolProps) => {
  return (
    <Box>
      <div className="flex gap-4 items-center justify-center">
        {institute.logo && (
          <Image
            src={institute.logo}
            alt={institute.name}
            width={64}
            height={64}
            className="rounded-md"
          />
        )}
        <div className="w-full mb-2 flex flex-col justify-center">
          <div className="flex justify-between">
            <h3 className="font-bold">{course}</h3>
            <span>{date}</span>
          </div>
          <h4>
            {institute.url ? (
              <a
                href={institute.url}
                target="_blank"
                rel="noopener noreferrer"
                className="underlined relative"
              >
                {institute.name}
              </a>
            ) : (
              <>{institute.name}</>
            )}
          </h4>
        </div>
      </div>
      <p className="text-sm mt-5">
        <strong>Course Contents: </strong>
        {technologies.join(", ")}
      </p>
    </Box>
  );
};

export { School };
